import { FC, useState } from 'react';
import { useProfileCalendarState } from '../../contexts/profileCalendar.context';
import { Box } from '@mui/material';
import CalendarComponent from '../../../../components/calendarComponent/calendarComponent';
import { EventClickArg } from '@fullcalendar/core';
import AddEventComponent from '../../../../components/addEventComponent/addEventComponent.view';
import { TEventsPrimary } from '../../../../../apis/events/events.interfaces';
import { useTranslation } from 'src/hooks/useTranslationHook';

const ProfileCalendarView: FC = () => {
  const { translateText } = useTranslation();
  const { calendarEvents } = useProfileCalendarState();
  const [isAddEventModalOpen, setIsAddEventModalOpen] = useState(false);

  const eventsForCalendar = calendarEvents.map((eachEvent) => ({
    title: eachEvent.title,
    date: eachEvent.startDate,
  }));

  const handleDateClick = (date: Date) => {
    console.log('Date clicked: ' + date);
    setIsAddEventModalOpen(true);
  };

  const handleEventClick = (event: EventClickArg) => {
    console.log('Event clicked: ' + event.event.title);
    setIsAddEventModalOpen(true);
  };

  const handleCloseAddEventModal = () => {
    setIsAddEventModalOpen(false);
  };

  const handleSubmitAddEvent = (event: Partial<TEventsPrimary>) => {
    console.log('Event submitted: ' + event.title);
  };

  return (
    <Box
      data-testid="profile-calendar-view"
      sx={{
        px: { xs: 0, sm: 0 },
        pt: { xs: 1, sm: 2 },
        pb: { xs: 2, sm: 4 },
      }}
    >
      <CalendarComponent
        events={eventsForCalendar}
        onDateClick={handleDateClick}
        onEventClick={handleEventClick}
      />
      <AddEventComponent
        isOpen={isAddEventModalOpen}
        onClose={handleCloseAddEventModal}
        onSubmit={handleSubmitAddEvent}
        title={translateText('profile.calendar.addEvent')}
        description={translateText('profile.calendar.addEventDescription')}
        eventDetails={null}
        isLoading={false}
        errorMessage=""
      />
    </Box>
  );
};

export default ProfileCalendarView;
